import { render, staticRenderFns } from "./CheckedIcon.vue?vue&type=template&id=30722692"
import script from "./CheckedIcon.vue?vue&type=script&lang=js"
export * from "./CheckedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports